import { Button, PasswordInput, TextInput } from '@mantine/core'
import { useForm } from '@mantine/form'
import ErrorAlert from 'common/ErrorAlert'
import { useLogin } from 'hooks/auth'
import { zodResolver } from 'mantine-form-zod-resolver'
import { Login, loginSchema } from 'types/auth'

export default function LoginForm() {
  const login = useLogin()

  const form = useForm<Login>({
    validate: zodResolver(loginSchema),
  })

  return (
    <form onSubmit={form.onSubmit(async (values) => await login.mutateAsync(values))}>
      <ErrorAlert mutation={login} />
      <TextInput label="Login" placeholder="Twój login" withAsterisk {...form.getInputProps('username')} />
      <PasswordInput label="Hasło" placeholder="Twoje hasło" withAsterisk mt="md" {...form.getInputProps('password')} />
      <Button type="submit" fullWidth mt="xl" loading={login.isPending}>
        Zaloguj
      </Button>
    </form>
  )
}
